export default {
  club_name: 'NO Prod',
  club_name_short: 'prod',
  stadium_name: '',
  staging_url: 'https://prod.api.fangroup.io',
  prod_url: 'https://prod.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/prod',
  club_logo: '/assets/teams/prod.png',
  app_name: 'prod',
  websale_name: 'prod',
  ntb_team_id: 10053,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'prod',
  monolithEnabled: false,
};
